import React, { useEffect, useState } from 'react';
import './shared.css';
import { useNavigate } from 'react-router-dom';
import Logo from './Images/pokitpal_logo_white.png';
import ReactGA from 'react-ga4';
import { goals } from '../Config/settings.js';


function EntryPage() {
    useEffect(() => {
  
ReactGA.send({ hitType: "pageview", page: window.location.pathname });
      }, []);

  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  console.log('welcome to rewards optimiser');

      const [selectedGoal, setSelectedGoal] = useState(null);

      const handleSelectGoal = (goal) => {
        localStorage.setItem('goal', goal);
        setIsSubmitting(true);
        navigate('/WeCanHelp');
        
      };

         
      const queryParams = new URLSearchParams(window.location.search);
      const cdrid = queryParams.get('cdrid');
      const existingValue = queryParams.get('existing') || 'false'; 
    
      // Optionally set in localStorage if needed elsewhere
      localStorage.setItem('cdrid', cdrid);
      localStorage.setItem('existing', existingValue);
    

return (
<div className="container">
<div className="logo-box">
    {<img src={Logo} alt="Logo" className="logo-image" />}
        
      </div>
  <div className="header">
    <h1 className="title">What is your primary <span style={{ color: '#F1E7B0' }}>money goal?</span></h1>
  <div className="card-box-container">
      {goals.map((goal, index) => (
        <div
          key={index}
          className={`card-box`}
          onClick={() => handleSelectGoal(goal)}
        >
          I want to {goal}
        </div>
      ))}
    </div>
    </div>



</div>

)
}

export default EntryPage;